import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ChannelUserFragment = { id: string, lastViewedAt: string, unreadCount?: number | null };


export type ChannelUserFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ChannelUserFragmentDoc = /*#__PURE__*/ gql`
    fragment ChannelUser on ChannelUserType {
  id
  lastViewedAt
  unreadCount
}
    `;